module.exports = __webpack_public_path__ + "img/225-maldives.40ec63ff.svg";